import { PureComponent } from 'react';
import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icon } from 'platfi-ui-components';

import { bemModifier } from 'utils/BEMHelper';
import styles from './ShareableReportHeader.scss';

@CSSModules(styles, { allowMultiple: true })
class ShareableReportHeader extends PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    reportType: PropTypes.string,
    subtitle: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    icon: PropTypes.string,
    primary: PropTypes.bool,
    printIntegrations: PropTypes.bool,
    secondary: PropTypes.bool,
  };

  render() {
    const {
      reportType,
      title,
      subtitle,
      children,
      primary,
      secondary,
      className,
      icon,
      printIntegrations,
    } = this.props;

    const stylesName = classNames(
      'm-shareable-report-header',
      ...bemModifier('m-shareable-report-header', {
        primary,
        'print-integrations': printIntegrations,
        secondary,
      }),
    );

    const headerClassName = classNames('o-container-d', className);

    return (
      <div styleName={stylesName} className={headerClassName}>
        <div className="o-col-7">
          <div styleName="m-shareable-report-header__type">{reportType}</div>
          <div styleName="m-shareable-report-header__title">{title}</div>
          <div styleName="m-shareable-report-header__subtitle">{subtitle}</div>
        </div>
        <div className="o-col-5">
          <div styleName="m-shareable-report-header__integrations">{children}</div>
        </div>

        {icon && <Icon icon={icon} styleName="m-shareable-report-header__bg-icon" />}
      </div>
    );
  }
}

export default ShareableReportHeader;
